export default __webpack_public_path__ + "static/media/delfinoTtsIt_It60.48b74010.mp3";